
export const BANK_CHOICES = [
    ["002", "산업"],
    ["003", "기업"],
    ["004", "국민"],
    ["007", "수협"],
    ["011", "농협"],
    ["020", "우리"],
    ["023", "SC제일"],
    ["027", "한국씨티"],
    ["031", "대구"],
    ["032", "부산"],
    ["034", "광주"],
    ["035", "제주"],
    ["037", "전북"],
    ["039", "경남"],
    ["045", "새마을금고"],
    ["048", "신협"],
    ["064", "산림조합"],
    ["071", "우체국"],
    ["081", "하나은행"],
    ["088", "신한"],
    ["089", "케이뱅크"],
    ["090", "카카오뱅크"],
    ["092", "토스뱅크"],
    ["999", "기타"],
]

export function displayBankName(bankCode: string) {
    return BANK_CHOICES.find(([code, label]) => code === bankCode)?.[1]
}